import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { useChatSettingsStore } from '#modules/chat/model/chatSettingsStore';
import { mutedChatsQueryOptions } from '#features/chats/model/chats';
import { useIsAuth } from '#modules/user/features/auth/hooks/useIsAuth';

/**
 * Наполнить зеркало заглушённых переписок сразу после входа.
 *
 * Заглушение хранит сервер, но всплывающему уведомлению ответ нужен мгновенно: решение
 * принимается в обработчике сокета, где до кеша запросов не дотянуться, поэтому на клиенте
 * живёт быстрое зеркало. Наполнялось оно из двух мест - списка чатов и открытой переписки, - и
 * на свежем устройстве, где ни экран чатов, ни саму переписку ещё не открывали, было пустым:
 * первая всплывашка из заглушённой переписки проскакивала, дальше уже нет.
 *
 * Поэтому запрос живёт здесь, в постоянно смонтированной раскладке, а не на экране чатов:
 * всплывашка приходит на любой странице, а зайти на экран чатов человек может и не зайти.
 */
export const useMutedChatsMirror = () => {
  const isAuth = useIsAuth();
  const replaceMutedChats = useChatSettingsStore((state) => state.replaceMutedChats);
  const { data } = useQuery({ ...mutedChatsQueryOptions(), enabled: isAuth });

  useEffect(() => {
    if (!data) {
      return;
    }
    replaceMutedChats(data);
  }, [data, replaceMutedChats]);
};
